import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type LightAggregatedProductCards as SchemaLightAggregatedProductCards } from '../schemas/LightAggregatedProductCards';
import { type ProductVariantRequest as SchemaProductVariantRequest } from '../schemas/ProductVariantRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 */
export const GetLightProductCardsByRequestContentType = 'application/json' as const;
export type GetLightProductCardsByRequestRequest = SchemaProductVariantRequest;
export type GetLightProductCardsByRequestResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaLightAggregatedProductCards;
    };
};
export type GetLightProductCardsByRequestResponseSuccess =
    GetLightProductCardsByRequestResponses['200']['application/json'];
export type GetLightProductCardsByRequestSearchParams = undefined;
export type GetLightProductCardsByRequestPathParameters = undefined;
export const GetLightProductCardsByRequestUrl = '/cards/search_light' as const;
export const GetLightProductCardsByRequestMethod = 'POST' as const;
export const getGetLightProductCardsByRequestUrl = (_params?: GetLightProductCardsByRequestPathParameters) =>
    GetLightProductCardsByRequestUrl;
